import { render, staticRenderFns } from "./cost-center-fba.vue?vue&type=template&id=24006058&scoped=true&"
import script from "./cost-center-fba.vue?vue&type=script&lang=js&"
export * from "./cost-center-fba.vue?vue&type=script&lang=js&"
import style0 from "./cost-center-fba.vue?vue&type=style&index=0&id=24006058&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24006058",
  null
  
)

export default component.exports